/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { MultiSelect, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import AuditRepository from '../../../helpers/api/AuditRepository';

export default class WorkSiteMultiSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: [],
      selectedItems: []
    };
    this.onChange = this.onChange.bind(this);
    this.repository = new AuditRepository();
  }

  async componentDidMount() {
    if (!this.props.division && this.props.loadAll === false) return;
    this.setState({ loading: true });
    const items = await this.getItems();
    this.setState({ items, selectedItems: this.props.initialSelectedItems, loading: false });
  }

  onChange = (selectedItem) => {
    const items = selectedItem ? selectedItem.selectedItems : null;
    this.setState({
      selectedItems: items
    });
    this.props.onChange(items);
  };

  getItems = async () => {
    let items = [];
    try {
      items = this.props.loadAll
        ? await this.repository.getWorkSites()
        : await this.repository.getWorkSites(this.props.division);
    } catch (error) {
        console.error(error);
      this.props.onError(error);
    }
    return items;
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <MultiSelect.Filterable
        id="ddlWorkSites"
        disabled={this.state.items < 1 || this.props.disabled}
        placeholder={
          this.state.selectedItems < 1
            ? 'Choose one or more items'
            : this.state.selectedItems.map((elem) => elem.name).join(', ')
        }
        label=""
        itemToString={(item) => (item ? item && item.name : '')}
        items={this.state.items}
        light={false}
        onChange={this.onChange}
        type="default"
        initialSelectedItems={this.props.initialSelectedItems}
      />
    );
  }
}

WorkSiteMultiSelect.propTypes = {
  division: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  loadAll: PropTypes.bool,
  initialSelectedItems: PropTypes.array,
  disabled: PropTypes.bool
};

WorkSiteMultiSelect.defaultProps = {
  division: null,
  loadAll: false,
  initialSelectedItems: [],
  disabled: true
};
